import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
export function PricingSection() {
  return <section id="compra" className="w-full bg-white py-20 px-4 border-t border-gray-200" data-id="element-176">
      <div className="max-w-5xl mx-auto" data-id="element-177">
        <div className="text-center mb-16" data-id="element-178">
          <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-179">
            Elige tu opción
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mt-6 leading-tight" data-id="element-180">
            La Opción Más Inteligente Es Obvia
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-181">
          {/* BÁSICA */}
          <div className="border-2 border-gray-200 rounded-2xl p-8 flex flex-col bg-white shadow-lg relative mt-4 md:mt-8" data-id="element-182">
            <div className="text-center mb-6" data-id="element-183">
              <h3 className="text-xl font-bold text-gray-600 uppercase tracking-wide" data-id="element-184">
                COLECCIÓN BÁSICA
              </h3>
              <p className="text-gray-500 font-medium mt-1" data-id="element-185">
                4 Tomos + 3 Bonos Gratis
              </p>
            </div>

            <div className="text-center mb-8" data-id="element-186">
              <div className="text-gray-400 line-through text-2xl font-bold mb-1" data-id="element-187">
                97€
              </div>
              <div className="text-5xl font-black text-gray-900" data-id="element-188">€19.99</div>
              <div className="text-sm text-gray-500 mt-2 font-medium" data-id="element-189">
                Pago único • Acceso inmediato
              </div>
              <div className="text-green-600 font-bold mt-1" data-id="element-190">
                Ahorrás más del 79%
              </div>
            </div>

            <div className="flex-grow mb-8" data-id="element-191">
              <div className="font-bold text-gray-800 mb-4" data-id="element-192">Incluye:</div>
              <ul className="space-y-3" data-id="element-193">
                {['Tomo 1 — Blindaje y Seguridad', 'Tomo 2 — El Kit del Ahorro', 'Tomo 3 — Instalaciones Pro', 'Tomo 4 — El Manual del Oficio'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-700 font-medium" data-id="element-194">
                    <Check size={18} className="text-green-500 shrink-0 mt-0.5" data-id="element-195" />{' '}
                    {item}
                  </li>)}
                {['Bono 1 — Kit de Emergencia', 'Bono 2 — Checklist Herramientas', 'Bono 3 — Guía Anti-Errores'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-700 font-medium" data-id="element-196">
                    <span className="shrink-0 mt-0.5" data-id="element-197">🎁</span> {item}
                  </li>)}
              </ul>
            </div>

            <a href="https://pagos.digipromarket.com/cart/56306135990598:1" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg py-4 rounded-lg text-center transition-colors shadow-md" data-id="element-198">
              Empezar con la Colección Básica →
            </a>
            <div className="text-center text-sm text-gray-500 mt-3 font-medium" data-id="element-199">
              Sin el Acelerador de Ingresos
            </div>
          </div>

          {/* PROFESIONAL */}
          <div className="border-4 border-blue-500 rounded-2xl p-8 flex flex-col bg-black text-white shadow-2xl relative transform md:-translate-y-4" data-id="element-200">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-yellow-400 text-black px-6 py-1.5 rounded-full font-black text-sm flex items-center gap-1 whitespace-nowrap shadow-md" data-id="element-201">
              <Star size={16} className="fill-black" data-id="element-202" /> LA OPCIÓN MÁS
              INTELIGENTE
            </div>

            <div className="text-center mb-6 mt-4" data-id="element-203">
              <h3 className="text-2xl font-black text-yellow-400 uppercase tracking-wide" data-id="element-204">
                EDICIÓN PROFESIONAL
              </h3>
              <p className="text-gray-300 font-medium mt-1" data-id="element-205">
                4 Tomos + Bonos + Acelerador de Ingresos
              </p>
            </div>

            <div className="text-center mb-8" data-id="element-206">
              <div className="text-gray-500 line-through text-2xl font-bold mb-1" data-id="element-207">
                147€
              </div>
              <div className="text-6xl font-black text-white" data-id="element-208">€29.99</div>
              <div className="text-sm text-gray-400 mt-2 font-medium" data-id="element-209">
                Pago único • Acceso inmediato
              </div>
              <div className="text-yellow-400 font-bold mt-1" data-id="element-210">
                Solo 10€ más que la Básica • Valor 147€
              </div>
            </div>

            <div className="flex-grow mb-8" data-id="element-211">
              <div className="font-bold text-gray-200 mb-4" data-id="element-212">Incluye:</div>
              <ul className="space-y-3" data-id="element-213">
                {['Tomo 1 — Blindaje y Seguridad', 'Tomo 2 — El Kit del Ahorro', 'Tomo 3 — Instalaciones Pro', 'Tomo 4 — El Manual del Oficio'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300 font-medium" data-id="element-214">
                    <Check size={18} className="text-blue-400 shrink-0 mt-0.5" data-id="element-215" />{' '}
                    {item}
                  </li>)}
                {['Bono 1 — Kit de Emergencia', 'Bono 2 — Checklist Herramientas', 'Bono 3 — Guía Anti-Errores'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300 font-medium" data-id="element-216">
                    <span className="shrink-0 mt-0.5" data-id="element-217">🎁</span> {item}
                  </li>)}
                <li className="pt-3 border-t border-gray-800" data-id="element-218"></li>
                {['El Acelerador de Ingresos', 'Plan 30 días — Primeros clientes', 'Guía de precios y presupuestos'].map((item, i) => <li key={i} className="flex items-start gap-2 text-yellow-400 font-bold" data-id="element-219">
                    <Star size={18} className="shrink-0 mt-0.5 fill-yellow-400" data-id="element-220" />{' '}
                    {item}
                  </li>)}
              </ul>
            </div>

            <motion.a href="https://pagos.digipromarket.com/cart/56306727715142:1" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-black text-xl py-5 rounded-lg text-center shadow-[0_5px_0_rgb(202,138,4)] hover:shadow-[0_2px_0_rgb(202,138,4)] hover:translate-y-[3px] transition-all uppercase" data-id="element-221">
              ⚡ SÍ, QUIERO LA EDICIÓN PROFESIONAL →
            </motion.a>
            <div className="text-center text-sm text-gray-400 mt-4 font-medium" data-id="element-222">
              Ahorrás más del 79% frente al precio normal
            </div>
          </div>
        </div>
      </div>
    </section>;
}